import { SubscriptSizing } from '@angular/material/form-field';
import { AnyType } from '@thehubz/shared/model';
import { ClientRole } from '../..';

/**
 * For creating form controls dynamically
 */
export interface FormControlModel extends FormControlBoolean, FormControlString, FormControlDate {
  value?: AnyType;
  options?: AnyType[];
  nestedOptions?: FormArrayMapping; // use with formArray and set nested option in dropdown (key as 0, 1, 2...)
  fieldType: FormFieldType;
  validators?: FormValidators;
  formFieldGroup?: FormControlModel[];
  accessibilityRole?: ClientRole;
  matDivider?: number; // where to place the divider in mat-select option list
  subscriptSizing?: SubscriptSizing; // Behaviors for how the subscript height is set.
  formArrayActionType?: 'add-n-remove' | 'single-button'; // for formArr
}

export interface FormControlBoolean {
  visible: boolean;
  disable?: boolean;
  withImg?: boolean;
  editOnly?: boolean;
  multiple?: boolean; // enable multi-select in dropdown options
  hideLabel?: boolean;
  mandatory?: boolean;
  showAvatar?: boolean;
  noTopBorder?: boolean;
  inlineImage?: boolean;
  hideFileList?: boolean;
  groupListView?: boolean;
  functionCall?: boolean;
  multipleFile?: boolean;
  dropDownSearch?: boolean;
  sortDataSource?: boolean;
  hideDetailsView?: boolean;
  repeatFieldLabel?: boolean; // for formArray
  enableMatOptGroup?: boolean;
  disableSingleSelect?: boolean;
  infotextExternalLink?: boolean;
}

export interface FormControlString {
  infotext?: string;
  assetType?: string;
  fieldLabel: string;
  inputType?: string;
  formTypeId: string;
  widthClass?: string;
  fieldGroup?: string;
  placeholder?: string;
  userInfotext?: string;
  extraClasses?: string;
  formFieldName: string;
  imgPreviewUrl?: string;
  linkableArray?: string[]; //Create mapping array with respect to other array
  fieldAssociated?: string[];
  formArrayExtraClasses?: string;
}

export interface FormControlDate {
  minDate?: Date;
  maxDate?: Date;
}

/**
 * For creating validator for form controls
 */
export interface FormValidators {
  min?: number;
  max?: number;
  email?: boolean;
  pattern?: string;
  minLength?: number;
  maxLength?: number;
  required?: boolean;
  requiredTrue?: boolean;
  nullValidator?: boolean;
}

export type FormArrayMapping = Record<number, AnyType>;

/**
 * List of form field types
 */
export type FormFieldType =
  | 'date'
  | 'text'
  | 'radio'
  | 'email'
  | 'space'
  | 'label'
  | 'number'
  | 'domains'
  | 'divider'
  | 'textarea'
  | 'checkbox'
  | 'dropdown'
  | 'formArray'
  | 'uploadFiles'
  | 'matChipList'
  | 'autocomplete'
  | 'assetGallery'
  | 'assetRelation'
  | 'treeHierarchy'
  | 'selectCheckBox'
  | 'multiSelectChip'
  | 'copyToClipboard'
  | 'confirmationLabel'
  | 'matChipListNoAutocomplete';
